import type { Options } from "ky";

import { postJson } from "#app/lib/fetchClient";

import { GATEWAY_PATHS } from "../api-utils";

type PostRegistrationUserParams = {
  body: {
    verificationGuid: string;
    alias: string;
    password: string;
    acceptedTsAndCs: boolean;
    friendlyName?: string;
  };
};

export async function postRegistrationUser(
  params: PostRegistrationUserParams & Pick<Options, "signal">,
): Promise<void> {
  // Call endpoint
  await postJson(
    `${GATEWAY_PATHS.externalBolRegistrationService}/Registration/User`,
    { json: params.body, signal: params.signal },
    true,
  );
}
